export function addZeroBefore(n) {
  return (n < 10 ? "0" : "") + n;
}

export function horasalida(fecha, hora, horas) {
  // fecha: "YYYY-MM-DD" (no se usa para el cálculo horario interno, solo la conservas si la necesitas)
  // hora: "HH:mm" o "HH:mm:ss"
  // horas: número (puede ser entero o decimal) a sumar
  const pad = (n) => String(n).padStart(2, "0");

  // Parse hora origen
  const [hStr, mStr, sStr = "0"] = hora.split(":");
  const h0 = parseInt(hStr, 10);
  const m0 = parseInt(mStr, 10);
  const s0 = parseInt(sStr, 10);

  // Convertimos a milisegundos desde inicio del día
  const startMs = ((h0 * 60 + m0) * 60 + s0) * 1000;

  // Horas a ms (acepta decimales)
  const addMs = horas * 3600 * 1000;

  const msInDay = 24 * 60 * 60 * 1000;

  // Suma aritmética pura
  let totalMs = startMs + addMs;

  // Normalizamos a rango 0..msInDay-1 (para soportar overflow y negativos)
  totalMs = ((totalMs % msInDay) + msInDay) % msInDay;

  const totalSeconds = Math.floor(totalMs / 1000);
  const hh = Math.floor(totalSeconds / 3600);
  const mm = Math.floor((totalSeconds % 3600) / 60);
  const ss = totalSeconds % 60;

  return `${pad(hh)}:${pad(mm)}:${pad(ss)}`;
}

export function formatTime(value) {
  if (value != null && value !== undefined) {
    return value.split(".")[0];
  }
  return "";
}